var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.install}},[_c('Marketing',{attrs:{"id":"auth"}}),_c('Install',{ref:"install"}),_c('WelcomeDialog',{ref:"welcome",attrs:{"handler":_vm.authDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }